import { Card, CardContent, makeStyles, Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import ActionTable from '../common/Table';
import { CommonConfig } from '../../../config/common-config';
import SearchBox from '../../../components/table/SearchBox';
import Button from '@material-ui/core/Button';
import { useHistory } from 'react-router';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(6),
    },
    container: {
        marginBottom: theme.spacing(1),
    },
    paper: {
        marginBottom: theme.spacing(1),
    },
    noRecord: {
        display: 'flex',
        justifyContent: 'center',
        background: '#f6f6f6',
        margin: '16px',
        '& h1': {
            alignSelf: 'center',
            color: 'grey',
            fontFamily: 'Rubik',
            fontSize: '14px',
            fontWeight: '400',
        },
    },
}));

const ItecInvoice = () => {
    const history = useHistory();
    const [searchQuery, setSearchQuery] = useState('');
    const [rows, setRows] = useState([]);
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const tennantname = tennantDetails && tennantDetails.tennantName;
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const axiosConfig = {
        headers: {
            Authorization: bearerToken,
        },
    };
    const [page, setPage] = useState(0);
    const [pageDetails, setPageDetails] = useState('');
    const [previousButton, setpreviousButton] = useState(false);
    const [nextButton, setnextButton] = useState(false);
    const [loading, setLoading] = useState(false);
    const [searchData, setSearchData] = useState([]);
    const [noRecordCount, setNoRecordCount] = useState(false);
    const [selectedImc, setselectedImc] = useState([]);

    function formatDate(props) {
        return props.map((element) => {
            const tempEndDate = element.dateModified;
            const tempInvoiceDate = element.invoiceDate;
            element.dateModified = tempEndDate.split(' ', 1);
            element.invoiceDate = tempInvoiceDate.split(' ', 1);
        });
    }

    const headcells = [
        { id: 'buyerName', label: 'Name' },
        { id: 'invoiceNumber', label: 'Invoice Number' },
        { id: 'invoiceDate', label: 'Invoice date' },
        { id: 'totalAmount', label: 'Invoice amount' },
        { id: 'dateModified', label: 'Email sent date' },
        { id: 'isPaid', label: 'Status' },
    ];

    const handleCount = (val) => {
        if (val === 'prev') {
            if (pageDetails.first !== true) {
                setPage((page) => page - 1);
            }
        }

        if (val === 'next') {
            if (pageDetails.last !== true) {
                setPage((page) => page + 1);
            }
        }
    };

    const setImc = (e) => {
        //console.log("E target" ,e)
        let imc = '';
        if (e.target) {
            imc = e.target.value;
        } else {
            imc = e;
        }
        setselectedImc(imc);
        setLoading(true);
        setpreviousButton(true);
        setnextButton(true);

        if (searchQuery && searchQuery.length > 2) {
            getSearchValue(searchQuery);
            setNoRecordCount(false);
            return true;
        } else {
            setSearchData([]);
            getInvoices(imc);
            setNoRecordCount(true);
            return false;
        }

    };

    // Set Rows
    const getInvoices = () => {
        setLoading(true);
        setpreviousButton(true);
        setnextButton(true);

        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/sinvoices/list/${tennantname}?page=${page}&size=10&sort=dateModified,desc`, axiosConfig)
            .then((response) => {
                formatDate(response.data.content);
                setRows(response.data.content);
                setPageDetails(response.data);
                setLoading(false);

                if (response.data.first) {
                    setpreviousButton(true);
                    setnextButton(false);
                } else if (response.data.last) {
                    setpreviousButton(false);
                    setnextButton(true);
                } else {
                    setpreviousButton(false);
                    setnextButton(false);
                }
            })
            .catch((error) => {
                //console.log("error", error.response);
            });
    };

    const getSearchValue = (data) => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/sinvoices/list/${tennantname}?search=${data}&page=${page}&size=10&sort=dateModified,desc`, axiosConfig)
            .then((res) => {
                // console.log('responseresponse11', res);
                if (res.data) {
                    if (res.data.content.length === 0) {
                        setRows([]);
                    }
                    formatDate(res.data.content);
                    setSearchData(res.data.content);
                    setPageDetails(res.data);
                    setLoading(false);
                    if (res.data.first) {
                        setpreviousButton(true);
                        setnextButton(false);
                    } else if (res.data.last) {
                        setpreviousButton(false);
                        setnextButton(true);
                    } else {
                        setpreviousButton(false);
                        setnextButton(false);
                    }
                }
            })
            .catch((error) => {
            });
    }

    const clearField = () => {
        setSearchQuery('');
        setSearchData([]);
        setPage(0);
        getInvoices(selectedImc);
        // console.log('clearclear')
    }

    // const history = useHistory();
    useEffect(() => {
        if (tennantname) {
            getInvoices();
        }
    }, [page, tennantDetails, userToken]);

    // handle search item
    const handleSearchQuery = (data) => {
        //console.log(data);
        setSearchQuery(data);
        console.log('data', data);
        if (data && data.length > 2) {
            setPage(0);
            setNoRecordCount(false);
            getSearchValue(data);
            return true;
        } else {
            setNoRecordCount(true);
        }
        if (!data) {
            setSearchData([]);
            setPage(0);
            getInvoices(selectedImc);
        }
    };

    // external css
    const classes = useStyles();

    const filteredRow = searchData && searchData.length ? searchData : rows;

    const back = () => {
        history.push({
            pathname: '/menu',
        })
    };

    return (
        <>
            <div className={classes.root}>
                <Card className="custom-table mb10">
                    <CardContent className="card-title-display">
                        <Grid item xs={12} sm={8}>
                            <Typography className="card-title">ITeC Service Invoice</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} className="card-search">
                            <div className="search-field">
                                <SearchBox searchQuery={searchQuery} onChange={handleSearchQuery} clearField={clearField} placeholder="Search..." />
                            </div>
                        </Grid>
                    </CardContent>
                    <CardContent className="card-table-display">
                        {rows && filteredRow.length > 0 ? (
                            <>
                                <ActionTable
                                    handleCount={handleCount}
                                    headcells={headcells}
                                    rows={filteredRow}
                                    pageDetails={pageDetails}
                                    action
                                    post="itec"
                                    mode="service"
                                    prvnxtbt={{ prvBt: previousButton, nxtBt: nextButton }}
                                    loading={loading}

                                />
                            </>
                        ) : (
                                <div className={classes.noRecord}>
                                    <h1>No records to display</h1>
                                </div>
                            )}
                    </CardContent>
                </Card>
                {/* <Layout title="ITeC Service Invoice" searchQuery={searchQuery} onChange={handleSearchQuery} className={classes}>
                {filteredRow.length === 0 && <span style={{ fontSize: '14px', fontWeight: '700' }}>No records found to display!</span>}
                <ActionTable headcells={headcells} rows={filteredRow} action post="itec" mode="service" /> 
            </Layout> */}
            </div>

            <Button variant="contained" onClick={() => back()} className="btnBlue txt-cap btnBckFloat" color="primary">
                Back
</Button>
        </>

    );
};

export default ItecInvoice;
